import { render, staticRenderFns } from "./CarregarControleManual.vue?vue&type=template&id=22651b57&scoped=true&"
import script from "./CarregarControleManual.vue?vue&type=script&lang=js&"
export * from "./CarregarControleManual.vue?vue&type=script&lang=js&"
import style0 from "./CarregarControleManual.vue?vue&type=style&index=0&id=22651b57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22651b57",
  null
  
)

export default component.exports